document.addEventListener 'turbo:load', => 
  $('.js-navbar-toggle').on 'click', (e) ->
    e.preventDefault()
    $('.js-navbar').toggleClass 'hidden'